import { useState, useContext } from 'react';
import { Container, Form, Row, Col, Button, Alert } from 'react-bootstrap';
import ContactCard from '../components/ContactCard';
import SocialIcons from '../components/SocialIcons';
import { ContactContext } from '../context/ContactContext';
import '../assets/scss/pages/review-us.scss';

function ReviewUs () {
    const API = process.env.REACT_APP_API_BASE_URL;
    const initialFormState = {
        name: "",
        comment: "",
        // variable names from here are same as API's (snakecase) to avoid conflicts
        reviewer_type: "",
    }
    const [formState, setFormState] = useState(initialFormState);
    const [formFeedback, setFormFeedback] = useState({ success: null, message: "" });
    const contact = useContext(ContactContext);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Build form data
        const formData = new FormData();

        // Append form fields to form data
        Object.keys(formState).forEach((key) => {
            formData.append(key, formState[key]);
        })

        try {
            const response = await fetch(`${API}/reviews/create/`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            // Unsuccessful API response
            if (!response.ok) {
                setFormFeedback({
                    success: false,
                    message: "Unable to add review, please try again",
                });
                console.error(data);
                return;
            }

            // Successful API response
            setFormFeedback({
                success: true,
                message: "Thank you for your feedback!",
            })
            // Clear form on successful ADDITION of review only
            setFormState(initialFormState);
        } catch (error) {
            setFormFeedback({
                success: false,
                message: "An unexpected error occured adding review.",
            })
            console.error(error);
        } finally {
            // Clear notification message after 20 seconds
            if (formFeedback.success) {
                setTimeout(() => setFormFeedback({ status: null, message: "" }), 20000);
            }
        };
    }

    return (
        <Container id="review-us" className="pt-2 pb-5">
            <div className="review-header d-flex align-items-center justify-content-center rounded-5">
                <h2 className="d-flex align-items-center fw-bold text-primary">REVIEW US</h2>
            </div>

            <Row as="section" className="d-flex py-5 justify-content-between" lg={2}>
                {/* Text & Social icons */}
                <Col className="my-3 px-4 px-md-1" lg={4}>
                    <Col className="py-md-4">
                        <p className="pb-2">Thank you for trusting Afinney Realty with your property purchase. Kindly leave a review of your experience with us here. We appreciate your feedback!</p>
                        <SocialIcons links={ contact && contact?.social_links } bg={ true } />
                    </Col>
                    <Col className="d-none d-lg-block">
                        <ContactCard /> {/* Contact prop not passed here since contact is gotten from ContactContext in ContactCard */}
                    </Col>
                </Col>

                {/* Form */}
                <Col className="my-3" lg={7}>
                    <Form onSubmit={ handleSubmit} className="review-form dashboard-form px-4 pt-5 pb-3 border rounded mx-auto">
                        <Row xs={1} md={2}>
                            {/* Name */}
                            <Form.Group controlId="name" className="mb-4">
                                <Form.Label>Name</Form.Label> {/* Replace * with (required) */}
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={ formState.name }
                                    onChange={ handleChange }
                                    placeholder="Title [First name] [Last name]"
                                    required
                                />
                            </Form.Group>

                            {/* Reviewer Type */}
                            <Form.Group controlId="reviewer_type" className="mb-4">
                                <Form.Label>Reviewer type</Form.Label> {/* Replace * with (required) */}
                                <Form.Select
                                    name="reviewer_type"
                                    value={ formState.reviewer_type}
                                    onChange={ handleChange }
                                >
                                    <option value="">Select</option>
                                    <option value="CLIENT">Buyer</option>
                                    <option value="DEVELOPER">Developer</option>
                                </Form.Select>
                            </Form.Group>
                        </Row>

                        {/* Comment */}
                        <Form.Group controlId="comment" className="mb-4">
                            <Form.Label>Comment</Form.Label> {/* Replace * with (required) */}
                            <Form.Control
                                as="textarea"
                                rows={10}
                                name="comment"
                                value={ formState.comment }
                                onChange={ handleChange }
                                placeholder="Please enter your comment here..."
                                required
                            />
                        </Form.Group>

                        <Button type="submit" className="w-100 px-3 px-md-5 mb-4">Submit review</Button>
                        { formFeedback.success != null &&
                            <Alert variant={formFeedback.success ? "primary" : "danger"} className="text-center">{ formFeedback.message }</Alert>
                        }
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default ReviewUs;
